<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    width="80%"
    :title="title"
    show-close
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
    v-el-dialog-drag
  >
    <Main ref="main" :statementData="statementData" />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="submit()">
        {{ $l('INDEX.btn_submit') || '提交' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { Main },
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    statementData: { type: Array, default: () => [] },
  },
  methods: {
    async submit() {
      const data = await this.$refs.main.getData()
      if (!data) return false

      this.loadingOpen()
      const res = await this.$api
        .shipmentPayStatementSubmitPayRequestApi(data)
        .catch(() => null)
      this.loadingClose()
      if (!res || !res.body) return
      this.close()
      this.$emit('reload')
      const code = res.body
      this.$router.push({
        name: 'transport-shipmentExpense-detail',
        params: { code, pageType: 'edit' },
      })
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
